export { useSaveQuote } from 'modules/Cube/communication/external/quotes.api.v1/ports/entitySaving/useSaveQuote'
